import React, { useMemo, useState } from "react"
import styled from '~/ui/styled'
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import { GradientCardFooter } from "./gradient-card-footer"
// import { useStores } from "~models"
import { useTheme } from '~/ui/styled'
import { Flex, StartFlex, GradientButton, Image, Text, CenterFlex, ColumnFlex } from "~components/El"
import { useStores } from "~models"
import { useChatList } from "~hooks/useChatList"
import useGroupActions from "~hooks/useGroupActions"
import { RedpacketStatus, RedPacketType } from "~proto"
import { globalToast } from "~utils"
import redlogo from "~assets/images/chat/redlogo.png"

const MainWrap = styled.View`
  align-items: center;
`

// 红包消息
export const RedEnvelopeMessage: React.FC<MessageProps> = observer(({ message }) => {
  // console.log('message----', message)
  const theme = useTheme()
  const { chatStore, userStore } = useStores()
  const { current } = chatStore
  const { attach = {}, created, receiver = {} } = message
  const redpacketInfo = attach?.redpacket_info

  const grapInfo = redpacketInfo?.grap_info || []
  const { openRedPacketPopup, openRedPacketDetailPopup, openExclusiveRedPacketDetailPopup } = useChatList()
  const { handleRedPacketDetail } = useGroupActions()
  const [loading, setLoading] = useState(false)
  // const isReceiver = receiver?.id === userStore.currentUser?.id // 接收方是否是自己
  const isSender = redpacketInfo?.sender_id === userStore.currentUser?.id // 发送方是否是自己
  const isGrap = grapInfo.some(item => item.receiver_id === userStore.currentUser?.id)
  const StatusDesc = useMemo(() => {
    if (redpacketInfo?.status === RedpacketStatus.ACTIVE) {
      // 待领取
      if (redpacketInfo.redpacket_type === RedPacketType.EXCLUSIVE) {
        return `给${receiver?.name}的专属红包`
      } else {
        if (isGrap) {
          return "已领取"
        } else {
          return "领取红包"
        }
      }
    } else if (redpacketInfo?.status === RedpacketStatus.FINISHED) {
      return "已领取"
    } else if (redpacketInfo?.status === RedpacketStatus.EXPIRED) {
      return "已过期"
    } else if (redpacketInfo?.status === RedpacketStatus.REFUNDED) {
      return "已退回"
    } else {
      return ""
    }
    
  }, [redpacketInfo?.status])

  const disabled = useMemo(() => {
    return [RedpacketStatus.FINISHED, RedpacketStatus.REFUNDED, RedpacketStatus.EXPIRED].includes(redpacketInfo?.status) || isGrap
  }, [redpacketInfo?.status, isGrap])
  // console.log('redpacketInfo', redpacketInfo)
  return (
    <GradientButton
        contentLayout="fill"
        width="100%"
        maxWidth="400px"
        minWidth="260px"
        height="88px"
        colors={redpacketInfo?.redpacket_type === RedPacketType.EXCLUSIVE ? ['#3acb6a', '#1ba54a'] : ['#fb994d', '#ee4b49']}
        // disabled={disabled}
        style={{ opacity: disabled ? 0.8 : 1 }}
        onClick={() => {
          if (loading) return
          setLoading(true)
          if (grapInfo?.length > 0) {
            if (redpacketInfo?.redpacket_type === RedPacketType.EXCLUSIVE) {
              openExclusiveRedPacketDetailPopup({ message, redpacketData: redpacketInfo })
              setLoading(false)
              return
            } else {
              openRedPacketDetailPopup({ message, redpacketData: redpacketInfo })
              setLoading(false)
              return
            }
          }
          
          handleRedPacketDetail({
            redpacket_id: redpacketInfo.redpacket_id
          }, (data) => {
            const redpacketData = data?.redpacket_data
            if (redpacketData?.status !== RedpacketStatus.ACTIVE) {
              message?.setRedPacketInfo({ status: redpacketData.status })
            }
            if (current?.isGameGroup && redpacketInfo.redpacket_type !== RedPacketType.EXCLUSIVE) {
              // 游戏群不能手动领取, 可以查看红包详情
              setLoading(false)
              openRedPacketDetailPopup({ message, redpacketData })
              return
            }
            if ([RedPacketType.EXCLUSIVE, RedPacketType.PRIVATE].includes(redpacketInfo.redpacket_type)) {
              // 群专属红包和私聊的红包, 只有发红包的人和领取的人才能打开
              if (redpacketData?.remaining_count === 0) {
                // 剩余数量为0, 打开红包详情
                openExclusiveRedPacketDetailPopup({ message, redpacketData })
              } else {
                // 剩余数量不为0并且发送人是自己, 打开红包详情
                if (userStore.currentUser?.id === redpacketData?.sender_id) openExclusiveRedPacketDetailPopup({ message, redpacketData })
                // 剩余数量不为0并且领取人是自己, 领取红包
                if (userStore.currentUser?.id === redpacketData?.target_user_id) openRedPacketPopup({ message })
              }
            } else {
              // 拼手气红包和普通红包
              if (redpacketData?.remaining_count === 0) {
                // 剩余数量为0,领取完毕, 打开红包详情
                openRedPacketDetailPopup({ message, redpacketData })
              } else {
                if (redpacketInfo.redpacket_type === RedPacketType.NORMAL && isSender) {
                  // 普通红包, 发红包的人不能领取红包,可查看红包详情
                  openRedPacketDetailPopup({ message, redpacketData })
                  
                } else {
                  // 剩余数量不为0,判断自己是否已经领取过, 领取过打开红包详情, 未领取领取, 打开红包领取弹窗
                  const grapInfo = redpacketData?.grap_info || []
                  // 判断自己是否已经领取过红包
                  const isGrap = grapInfo.some(item => item.receiver_id === userStore.currentUser?.id)
                  if (isGrap) {
                    // 领取过打开红包详情
                    openRedPacketDetailPopup({ message, redpacketData })
                  } else {
                    // 未领取领取, 打开红包领取弹窗
                    openRedPacketPopup({ message })
                  }
                }
              }
            }
            setLoading(false)
          }, (error) => {
            globalToast.show(error?.message || "打开失败")
            setLoading(false)
          })
        }}
       
    >
      <StartFlex flexDirection="column" flex={1} width="100%" padding="4px 12px">
        <Flex width="100%" padding="8px 0">
          <CenterFlex width="36px" height="36px">
            <Image width="100%" height="100%" src={redlogo} />
          </CenterFlex>
          <ColumnFlex height="auto" flexDirection="column" ml="8px" style={{ flex: 1, minWidth: 0, paddingRight: 5 }}>
                <Text numberOfLines={1} fontSize={theme.fontSizes.md} color={theme.colors.textLight}>{redpacketInfo?.blessing_words || "恭喜发财，大吉大利"}</Text>
                <Text fontSize={theme.fontSizes.sm} color={theme.colors.textLight}>{StatusDesc}</Text>
            </ColumnFlex>
        </Flex>
        <GradientCardFooter label="企鹅红包" time={created} textColor={theme.colors.textLight} />
      </StartFlex>
    </GradientButton>
  )
})

export const WrappedRedEnvelopeMessage: React.FC<MessageProps> = (props) => {
  return (
    <MainWrap>
    {/* <WrappedTextMessage {...props} setPopupOptionListModal={null} /> */}
      {props.message.byMe ? (
        <MessageSent {...props} Component={RedEnvelopeMessage} isNoBg={true} />
      ) : (
        <MessageReceived {...props} Component={RedEnvelopeMessage} isNoBg={true} />
      )}
    </MainWrap>
  )
}
export default WrappedRedEnvelopeMessage
